import React from 'react';
import { useTranslation } from 'react-i18next';
import { RadioButtons } from 'components/ExperienceView/sub-components/RadioButtons';
import moment from 'moment';
import { SessionSidebarBlock, SidebarSubtitle } from './styles';

interface Duration {
  value: string;
  label: string;
  durationInMinutes: moment.Duration;
}

interface DurationSelectorProps {
  durations: Duration[];
  isFlexibleDurationEnabled: boolean;
  selectedDuration: string;
  setSelectedDuration: (duration: string | number | null) => void;
}

const DurationSelector = ({
  durations,
  isFlexibleDurationEnabled,
  selectedDuration,
  setSelectedDuration,
}: DurationSelectorProps) => {
  const { t: translate } = useTranslation();

  if (!isFlexibleDurationEnabled || durations.length < 2) {
    return null;
  }

  return (
    <SessionSidebarBlock>
      <SidebarSubtitle className="experience-view-sidebar-help">
        {translate('selectDuration')}:
      </SidebarSubtitle>
      <RadioButtons
        asBtn
        wrap={false}
        value={selectedDuration}
        options={durations}
        name="sessionDuration"
        onChange={(v) => setSelectedDuration(v)}
      />
    </SessionSidebarBlock>
  );
};

export default DurationSelector;
